import callApi from './callApi';
export const getTestSuites = async (
  projectId,
  page,
  perPage,
  searchValue,
  status = 'all'
) => {
  const url = `testsuites?projectId=${projectId}&page=${page}&perPage=${perPage}&search=${searchValue || ''
    }&status=${status}`;

  return await callApi(url, {}, 'GET');
};

export const getTestSuiteRecommendation = async (
  projectId,
  testcycleId,
  searchValue,
) => {
  const url = `testsuites/recommend?projectId=${projectId}&testcycleId=${testcycleId}&search=${searchValue || ''
    }`;

  return await callApi(url, {}, 'GET');
};

export const getTestSuitesWithMetrics = async (
  projectId,
  page,
  perPage,
  searchValue,
  status = 'all'
) => {
  const url = `testsuites/details?projectId=${projectId}&page=${page}&perPage=${perPage}&search=${searchValue || ''
    }&status=${status}`;

  return await callApi(url, {}, 'GET');
};

export const suspendTestSuite = async ({ status, id }) => {
  const url = `testsuites/status/${id}`;

  const body = {
    status
  };
  return callApi(url, {}, 'PUT', body);
};

export const deleteTestSuite = async (id) => {
  const url = `testsuites/${id}`;

  return callApi(url, {}, 'DELETE');
};

export const getTestCasesBySuite = async (id, page, perPage, onlyApproved, testCycleId) => {
  const url = `testsuites/${id}?page=${page}&perPage=${perPage}&onlyApproved=${onlyApproved || false}${testCycleId ? `&testCycleId=${testCycleId}` : ''}`;
  return callApi(url, {}, 'GET');
};

export const getTestCasesNotInSuite = async (id, projectId, page, perPage, searchValue, queryString) => {
  const url = `testsuites/testcases/${id}?projectId=${projectId}&page=${page}&perPage=${perPage}&search=${searchValue || ''}${queryString ? `&${queryString}` : ''}`;

  return callApi(url, {}, 'GET');
};

export const addTestCasesToSuite = async (id, testCaseIds) => {
  const url = `testsuites/add-testcases/${id}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    testCaseIds,
  };
  return await callApi(url, headers, 'POST', body);
};

export const removeTestCasesfromSuite = async (id, testCaseId) => {
  const url = `testsuites/remove-testcases/${id}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    testCaseId,
  };
  return await callApi(url, headers, 'PUT', body);
};

export const removeTestSuite = async (id) => {
  const url = `testsuites/${id}`;

  return callApi(url, {}, 'DELETE');
};

export const createTestSuite = async (testsuite) => {
  const url = `testsuites`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    testsuite,
  };
  return await callApi(url, headers, 'POST', body);
};

export const updateTestSuite = async (testsuite) => {
  let url = `testsuites/${testsuite.id}`;
  let body = {
    testsuite,
  };
  return await callApi(url, {}, 'PUT', body);
};

export const updateTestSuiteCountries = async (payload) => {
  let url = `testsuites/update-countries`;
  let body = {
    ...payload,
  };
  return await callApi(url, {}, 'PUT', body);
};

export const handleDeleteText =
  'Are you sure you want to permanently delete this test suite? This action cannot be undone.';
export const handleSuspendText =
  'Are you sure you want to mark this test suite as suspended?';
export const handleActivateText =
  'Are you sure you want to activate this test suite again?';


